import React, { useEffect, useState } from 'react';
import { Outlet, NavLink, Link, useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Home, Package, Calendar, Phone, Menu, X } from 'lucide-react';
import { Toaster } from 'sonner';
import { WhatsAppButton } from './WhatsAppButton';
import { Logo } from './Logo';
export const Layout = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const navItems = [{
    path: '/',
    label: 'Početna',
    icon: Home
  }, {
    path: '/ponuda',
    label: 'Ponuda',
    icon: Package
  }, {
    path: '/cjenik',
    label: 'Cjenik',
    icon: Package
  }, {
    path: '/galerija',
    label: 'Galerija',
    icon: Package
  }, {
    path: '/rezervacija',
    label: 'Rezervacija',
    icon: Calendar
  }, {
    path: '/kontakt',
    label: 'Kontakt',
    icon: Phone
  }];
  const mobileNavItems = [{
    path: '/',
    label: 'Početna',
    icon: Home
  }, {
    path: '/ponuda',
    label: 'Ponuda',
    icon: Package
  }, {
    path: '/rezervacija',
    label: 'Rezerviraj',
    icon: Calendar
  }, {
    path: '/kontakt',
    label: 'Kontakt',
    icon: Phone
  }];
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    const returnToHome = () => {
      const isReturningToOffer = window.location.pathname === '/ponuda' && Boolean(sessionStorage.getItem('jumpland_offer_position'));
      if (window.location.pathname !== '/' && !isReturningToOffer) navigate('/', {
        replace: true
      });
    };
    window.addEventListener('popstate', returnToHome);
    return () => window.removeEventListener('popstate', returnToHome);
  }, [navigate]);
  const scrollToTop = () => {
    sessionStorage.removeItem('jumpland_offer_position');
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  };
  const shouldScrollToTop = (path: string) => ['/ponuda', '/cjenik', '/uvjeti'].includes(path);
  return <div className="min-h-screen bg-background flex flex-col font-sans" data-id="element-83" data-mp="29hhxwcc4etsr">
      <Toaster position="top-center" richColors data-id="element-84" data-mp="24khu682qu34t" />

      {/* Desktop Header */}
      <header className="bg-white shadow-sm sticky top-0 z-40" data-id="element-85" data-mp="1gsswec75kmgh">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86" data-mp="1gr9hoq15ajgt">
          <div className="relative flex h-32 items-center justify-start" data-id="element-87" data-mp="1bw2h3r369uw4">
            <Link to="/" aria-label="JumpLand početna" className="group absolute left-1/2 -translate-x-1/2" data-id="element-88" data-mp="1qkgs4paqspnr">
              <Logo size="xl" data-id="element-89" data-mp="y34crf8r4sgf" />
            </Link>

            <button type="button" aria-label={isMobileMenuOpen ? 'Zatvori izbornik' : 'Otvori izbornik'} aria-expanded={isMobileMenuOpen} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="inline-flex items-center gap-2 rounded-xl px-3 py-2 font-bold text-gray-700 transition-colors hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary" data-id="element-90" data-mp="y1jkxxdtnnm9">
              {isMobileMenuOpen ? <X size={24} data-id="element-91" data-mp="2zrig960pcgvo" /> : <Menu size={24} data-id="element-92" data-mp="2zt1uys6pmjvc" />}
              <span className="hidden sm:inline" data-id="element-93" data-mp="2zq7dn9iztf65">Izbornik</span>
            </button>
          </div>
        </div>
        <div className="h-1 w-full bg-primary" data-id="element-94" data-mp="3ng1jh74wa3gw" />
      </header>

      <AnimatePresence data-id="element-95" data-mp="3sgfm29nq8l7j">
        {isMobileMenuOpen && <>
            <motion.button type="button" aria-label="Zatvori izbornik" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsMobileMenuOpen(false)} className="fixed inset-0 z-40 bg-gray-900/20" data-id="element-96" data-mp="3ehy46ski62xj" />
            <motion.aside initial={{
          opacity: 0,
          x: -32
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -32
        }} transition={{
          duration: 0.2
        }} aria-label="Glavni izbornik" className="fixed left-0 top-0 z-50 flex h-full w-[min(22rem,88vw)] flex-col border-r border-gray-100 bg-white p-6 shadow-2xl" data-id="element-97" data-mp="271i5iqjis9kw">
              <div className="flex items-center justify-between border-b border-gray-100 pb-5" data-id="element-98" data-mp="28js0ygjf6j17">
                <span className="text-lg font-display font-bold text-gray-900" data-id="element-99" data-mp="367is1yrz3ins">
                  Izbornik
                </span>
                <button type="button" onClick={() => setIsMobileMenuOpen(false)} aria-label="Zatvori izbornik" className="rounded-xl p-2 text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary" data-id="element-100" data-mp="2wb5tamhkmem6">
                  <X size={24} data-id="element-101" data-mp="1gufdbw0ztzru" />
                </button>
              </div>
              <nav className="mt-5 space-y-2" data-id="element-102" data-mp="3si0lzmpiycj4">
                {navItems.map(item => {
              const Icon = item.icon;
              return <NavLink key={item.path} to={item.path} onClick={shouldScrollToTop(item.path) ? scrollToTop : undefined} className={({
                isActive
              }) => `flex items-center gap-3 rounded-2xl px-4 py-4 text-lg font-bold transition-colors ${isActive ? 'bg-primary/10 text-primary' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-103" data-mp="eho7ukvuj73">
                      <Icon size={20} data-id="element-104" data-mp="o1zlg5mx29hg" />
                      {item.label}
                    </NavLink>;
            })}
              </nav>
            </motion.aside>
          </>}
      </AnimatePresence>

      {/* Main Content */}
      <main className="flex-grow pb-24 md:pb-0" data-id="element-105" data-mp="2uv1o58n3iyjn">
        <Outlet data-id="element-106" data-mp="1zs3c1x6jikn" />
      </main>

      {/* Floating WhatsApp Button */}
      <WhatsAppButton data-id="element-107" data-mp="201s5m6hnjor" />

      {/* Mobile Bottom Navigation */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 bg-white border-t border-gray-200 flex justify-around items-center h-16 z-40 pb-safe" data-id="element-108" data-mp="3t74kigy2bw0k">
        {mobileNavItems.map(item => {
        const Icon = item.icon;
        return <NavLink key={item.path} to={item.path} onClick={shouldScrollToTop(item.path) ? scrollToTop : undefined} className={({
          isActive
        }) => `flex flex-col items-center justify-center w-full h-full ${isActive ? 'text-primary' : 'text-gray-500'}`} data-id="element-109" data-mp="63hn8e2wtbzc">
              {({
            isActive
          }) => <>
                  <div className={`p-1.5 rounded-full transition-colors ${isActive ? 'bg-primary/10' : ''}`} data-id="element-110" data-mp="prqg6qca1lzw">
                    <Icon size={20} strokeWidth={isActive ? 3 : 2.5} data-id="element-111" data-mp="yr3pnj0eiakm" />
                  </div>
                  <span className="text-[10px] font-bold mt-0.5" data-id="element-112" data-mp="1icvuz7igiy01">
                    {item.label}
                  </span>
                </>}
            </NavLink>;
      })}
      </nav>

      {/* Desktop Footer */}
      <footer className="hidden md:block bg-white border-t border-gray-100 py-12 mt-auto" data-id="element-113" data-mp="18fr62zx88ofj">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-114" data-mp="1dawr7wit1z2k">
          <div className="flex justify-center items-center mb-4 group" data-id="element-115" data-mp="zl2yh346iunk">
            <Logo size="md" data-id="element-116" data-mp="14bt66n02v9lf" />
          </div>
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-medium" data-id="element-117" data-mp="14cutpqya5ok1">
            <Link to="/uvjeti" className="text-gray-500 hover:text-primary" data-id="element-118" data-mp="pohu8jzzhnks">
              Uvjeti najma
            </Link>
            <Link to="/politika-privatnosti" className="text-gray-500 hover:text-primary" data-id="element-119" data-mp="umjdb4xetmw9">
              Politika privatnosti
            </Link>
          </div>
          <p className="mt-4 text-gray-500 text-sm font-medium" data-id="element-120" data-mp="knaqqx4vjajx">
            &copy; {new Date().getFullYear()} JumpLand. Sva prava pridržana.
          </p>
        </div>
      </footer>
    </div>;
};